<template lang="pug">
  header
    Branding(:brand="config.brand", :sponsor="config.sponsor", :lab="config.lab")
</template>

<script>
import { mapState } from 'vuex'
import Branding from '@/components/Branding'

export default {
  name: 'Header',
  components: {
    Branding
  },
  computed: mapState([
    'config'
  ])
}
</script>

<style lang="scss" scoped>
  header {
    position: fixed;
    left: 0;
    right: 0;
    z-index: 6;
    background-color: white;
    will-change: transform;
    transition: all .3s;
    border-bottom: 1px solid #dedede;
    // @media all and (max-width: 900px){
    //   transform: translateY(-90px);
    // }
    &.scrolled{
      // @media all and (min-width: 900px){
      //   transform: translateY(-90px);
      // }
    }
  }
</style>

